import { FC } from 'react';
import classNames from 'classnames';
import { Candidate, TagIdentifier } from '../styled';
import { CandidateImage } from './CandidateImage';
import { ContributionBanner } from 'components/Cards/CandidateCard/ContributionBanner';
import type { ContributionSummaryView } from 'store/contributionSummary/types';
import type { CandidateType } from './Candidates';
import { getArePartnerTagsEnabled, getIsCandidateTagVisible } from './utils';

interface CandidateItemProps {
  candidate: CandidateType;
  hasOneRecipientOnly: boolean;
  // Donor's cycle giving to this recipient; the pill renders only for positive totals.
  summary?: ContributionSummaryView;
  urlPartner?: string;
}

// One recipient row on the compact/event slate: image, name block, and (when the
// donor has given this cycle) the "Donated" pill. Shared by the desktop grid and
// the mobile column, which differ only in container and page size.
export const CandidateItem: FC<CandidateItemProps> = ({
  candidate,
  hasOneRecipientOnly,
  summary,
  urlPartner,
}) => (
  <Candidate
    className={classNames('compact-candidate', { 'single-recipient': hasOneRecipientOnly })}
    $alignItems="center"
    $isSelected={candidate.isSelected}
    $whiteBackground={getArePartnerTagsEnabled(urlPartner)}
  >
    <CandidateImage recipientId={candidate.misc_ids?.photo_id} />
    <div className="compact-candidate-info">
      <div>{candidate.recipient_name}</div>
      <div>{candidate.race?.election.display_info}</div>
      {getIsCandidateTagVisible(candidate.de_id, urlPartner) && (
        <TagIdentifier>LGBTQ+</TagIdentifier>
      )}
    </div>
    {summary && summary.cycle_total > 0 && (
      <div className="compact-summary-right">
        <ContributionBanner amountDollars={summary.cycle_total} variant="pill" />
      </div>
    )}
  </Candidate>
);
